import { all, call, put, takeEvery } from "redux-saga/effects";
import axiosMain from "../../../http/axios/axios_main";
import axios from "axios";
import {
  GET_VIEW_TEA_SOLD,
  GET_VIEW_TEA_SOLD_LOT,
  GET_VIEW_TEA_SOLD_LOT_MARKET,
  GET_VIEW_TEA_AUCTIONEER,
  GET_VIEW_MARKET_SUMMARY,
  GET_MY_PLANNER_ENG,
  GET_MY_CATALOG_VIEW,
  GET_MY_CATALOG_ADD,
  GET_MY_CATALOG_REMOVE,
  CHANGE_RESERVE_PRICE,
  GET_MARKET_DEPTH,
  COLUMN_CONFIG_TABLE,
  USERWISE_CONFIG_TABLE,
  DEFULT_CONFIG_TABLE,
  GROUP_CODE_TABLE,
  ADD_VALUATION_ACTION,
} from "../../actionLabels";
import CustomToast from "../../../components/Toast";
import {
  getViewTeaSoldIdActionFail,
  getViewTeaSoldByIdActionSuccess,
  getViewTeaSoldByLotIdActionSuccess,
  getViewTeaSoldByLotIdActionFail,
  getViewTeaSoldMarketByIdActionSuccess,
  getViewTeaSoldMarketIdActionFail,
  getauctioneerByIdActionSuccess,
  getauctioneerIdActionFail,
  getviewmarketsummaryByIdActionSuccess,
  getviewmarketsummaryIdActionFail,
  getMyplannerActionSuccess,
  getMyplannerIdActionFail,
  MyCatalogViewActionSuccess,
  MyCatalogViewIdActionFail,
  AddMyCatalogActionSuccess,
  AddMyCatalogActionFail,
  RemoveMyCatalogActionSuccess,
  RemoveMyCatalogActionFail,
  MyCatalogStutas,
  ChangeReservePriceActionSuccess,
  ChangeReservePriceActionFail,
  AddMyCatalogStutas,
  RemoveMyCatalogStutas,
  ChangeReservePriceStutas,
  getMarketDepthActionSuccess,
  getMarketDepthIdActionFail,
  CatalogColumnConfigActionSuccess,
  CatalogColumnConfigActionFail,
  UserwiseCloumnConfigActionSuccess,
  UserwiseCloumnConfigActionFail,
  DefaultCloumnConfigActionFail,
  DefaultCloumnConfigActionSuccess,
  UserwiseCloumnConfigStatus,
  DefaultCloumnConfigStutas,
  GetGroupCodeActionSuccess,
  GetGroupCodeActionFail,
  addvaluationSuccess,
  addvaluationActionFail,
  addvaluationStatus,
  MyCatalogViewLoading,
  MyPlannerViewLoading,
  MyViewMarketSummaryViewLoading,
  MyViewTeaSoldMarketViewLoading,
  MyViewTeaSoldViewLoading,
  MyViewTeaSoldByLotViewLoading,
  MyAuctioneerViewLoading,
  MyMarketDepthLoading,
  fetchBidBookExportSuccess,
  isRpButtonClikedFalse
} from "../../actions";

function* getViewTeaSoldById(action) {
  try {
    yield put(MyViewTeaSoldViewLoading());
    const auctionDetailId = action.payload;
    const UserData = yield call(
      axiosMain.get,
      `/englishauction/viewteasoldsummary/${auctionDetailId}`
    );
    if (UserData.status == 200) {
      yield put(getViewTeaSoldByIdActionSuccess(UserData.data));
    } else {
      yield put(getViewTeaSoldIdActionFail(UserData.data.message));
    }
  } catch (error) {
    yield put(getViewTeaSoldIdActionFail(error));
  }
}

function* getViewTeaSoldByLotId(action) {
  try {
    yield put(MyViewTeaSoldByLotViewLoading());
    const auctionDetailId = action.payload.auctionDetailId;
    const auctionItemDetailId = action.payload.auctionItemDetailId;
    const UserData = yield call(
      axiosMain.get,
      `/englishauction/viewteasoldsummarybylot/${auctionDetailId}/${auctionItemDetailId}`
    );
    if (UserData.status == 200) {
      yield put(getViewTeaSoldByLotIdActionSuccess(UserData.data));
    } else {
      yield put(getViewTeaSoldByLotIdActionFail(UserData.data.message));
    }
  } catch (error) {
    yield put(getViewTeaSoldByLotIdActionFail(error));
  }
}

function* getViewTeaSoldMarketById(action) {
  try {
    yield put(MyViewTeaSoldMarketViewLoading());
    const commonUserId = action.payload.commonUserId;
    const auctionDetailId = action.payload.auctionDetailId;
    const UserData = yield call(
      axiosMain.get,
      `/englishauction/viewauctioneermarketsummary/${auctionDetailId}/${commonUserId}`
    );
    if (UserData.status == 200) {
      yield put(getViewTeaSoldMarketByIdActionSuccess(UserData.data));
    } else {
      yield put(getViewTeaSoldMarketIdActionFail(UserData.data.message));
    }
  } catch (error) {
    yield put(getViewTeaSoldMarketIdActionFail(error));
  }
}

function* getauctioneerById(action) {
  try {
    yield put(MyAuctioneerViewLoading());
    const auctionDetailId = action.payload;
    const UserData = yield call(
      axiosMain.get,
      `/englishauction/viewauctioneersbyauctionid/${auctionDetailId}`
    );

    if (UserData.status == 200) {
      yield put(getauctioneerByIdActionSuccess(UserData.data));
    } else {
      yield put(getauctioneerIdActionFail(UserData.data.message));
    }
  } catch (error) {
    yield put(getauctioneerIdActionFail(error));
  }
}

function* getviewmarketsummarById(action) {
  try {
    yield put(MyViewMarketSummaryViewLoading());
    const auctionDetailId = action.payload;
    const UserData = yield call(
      axiosMain.get,
      `/englishauction/viewmarketsummary/${auctionDetailId}`
    );

    if (UserData.status == 200) {
      yield put(getviewmarketsummaryByIdActionSuccess(UserData.data));
    } else {
      yield put(getviewmarketsummaryIdActionFail(UserData.data.message));
    }
  } catch (error) {
    yield put(getviewmarketsummaryIdActionFail(error));
  }
}
function* getMyplannerById(action) {
  try {
    
    const commonUserId = action.payload.commonUserId;
    const auctionDetailId = action.payload.auctionDetailId;
    const isExport = action.payload.isExport == undefined ? 0 : action.payload.isExport;
    const exportType = action.payload.exportType == undefined ? 'pdf' : action.payload.exportType;
    if(isExport == 0)
    yield put(MyPlannerViewLoading());
    const UserData = yield call(
      axiosMain.get,
      `/englishauction/getmyplannerdata/${auctionDetailId}/${commonUserId}/${isExport}/${exportType}`
    );

    if (UserData.status == 200) {
      if(isExport==1){
        UserData.data.responseData.sahilfrom = "myplanner";
        UserData.data.responseData.exportType=exportType;
        yield put(fetchBidBookExportSuccess(UserData.data));
      }else{
        yield put(getMyplannerActionSuccess(UserData.data));
      }
    } else {
      yield put(getMyplannerIdActionFail(UserData.data.message));
    }
  } catch (error) {
    yield put(getMyplannerIdActionFail(error));
  }
}

function* MyCatalogViewId(action) {
  try {
    yield put(MyCatalogViewLoading());
    const userLoginId = action.payload.userLoginId;
    const auctionDetailId = action.payload.auctionDetailId;
    const UserData = yield call(
      axiosMain.get,
      `/englishauction/viewmycatalog/${auctionDetailId}/${userLoginId}`
    );
    if (UserData.status == 200) {
      yield put(MyCatalogViewActionSuccess(UserData.data));
      yield put(MyCatalogStutas(true));
    } else {
      yield put(MyCatalogViewActionSuccess(UserData.message));
    }
  } catch (error) {
    yield put(MyCatalogViewIdActionFail(error));
  }
}

function* AddMyCatalog(action) {
  try {
    const UserData = yield call(
      axiosMain.post,
      `/englishauction/addmycatalog`,
      action.payload
    );
    if (UserData.status == 200) {
      yield put(AddMyCatalogActionSuccess(UserData.data));
      yield put(AddMyCatalogStutas(true));
      CustomToast.success(UserData.data.message);
    } else {
      yield put(AddMyCatalogActionFail(UserData.data.message));
    }
  } catch (error) {
    yield put(AddMyCatalogActionFail(error));
  }
}

function* RemoveMyCatalog(action) {
  try {
    const UserData = yield call(
      axiosMain.post,
      `/englishauction/removemycatalog`,
      action.payload
    );
    if (UserData.status == 200) {
      yield put(RemoveMyCatalogActionSuccess(UserData.data));
      CustomToast.success(UserData.data.message);
      yield put(RemoveMyCatalogStutas(true));
    } else {
      yield put(RemoveMyCatalogActionFail(UserData.data.message));
    }
  } catch (error) {
    yield put(RemoveMyCatalogActionFail(error));
  }
}

function* ChangeReservePrice(action) {
  try {
    const UserData = yield call(
      axiosMain.post,
      `/englishauction/changerpUI`,
      action.payload
    );
    if (UserData.status == 200) {
      yield put(ChangeReservePriceActionSuccess(UserData.data));
      yield put(ChangeReservePriceStutas(true));
    } else {
      yield put(ChangeReservePriceActionFail(UserData.data.message));
    }
  } catch (error) {
    yield put(ChangeReservePriceActionFail(error));
  } finally{
    yield put(isRpButtonClikedFalse())
  }
}

function* getMarketDepthById(action) {
  try {
    yield put(MyMarketDepthLoading());
    const auctionItemDetailId = action.payload.auctionItemDetailId;
    const auctionDetailId = action.payload.auctionDetailId;
    const userLoginId = action.payload.userLoginId;
    const UserData = yield call(
      axiosMain.get,
      `/englishauction/viewmarketdepth/${auctionDetailId}/${auctionItemDetailId}/${userLoginId}`
    );

    if (UserData.status == 200) {
      yield put(getMarketDepthActionSuccess(UserData.data));
    } else {
      yield put(getMarketDepthIdActionFail(UserData.data.message));
    }
  } catch (error) {
    yield put(getMarketDepthIdActionFail(error));
  }
}

function* CatalogColumnConfigAction(action) {
  try {
    const UserData = yield call(
      axiosMain.post,
      `/englishauction/addmycatalogcolumnconfig`,
      action.payload
    );
    if (UserData.status == 200) {
      yield put(CatalogColumnConfigActionSuccess(UserData.data));
      yield put(UserwiseCloumnConfigStatus(true));
      CustomToast.success(UserData.data.message);
    } else {
      yield put(CatalogColumnConfigActionFail(UserData.data.message));
    }
  } catch (error) {
    yield put(CatalogColumnConfigActionFail(error));
  }
}

function* UserwiseCloumnConfigById(action) {
  try {
    const auctionDetailId = action.payload.auctionDetailId;
    const userLoginId = action.payload.userLoginId;
    const UserData = yield call(
      axiosMain.get,
      `/englishauction/getmycataloguserwisecolumnconfig/${userLoginId}/${auctionDetailId}`
    );

    if (UserData.status == 200) {
      yield put(UserwiseCloumnConfigActionSuccess(UserData.data));
    } else {
      yield put(UserwiseCloumnConfigActionFail(UserData.data.message));
    }
  } catch (error) {
    yield put(UserwiseCloumnConfigActionFail(error));
  }
}

function* DefaultCloumnConfigById(action) {
  try {
    const auctionDetailId = action.payload.auctionDetailId;
    const userLoginId = action.payload.userLoginId;
    const UserData = yield call(
      axiosMain.get,
      `/englishauction/getmycataloguserwisedefaultcolumnconfig/${userLoginId}/${auctionDetailId}`
    );

    if (UserData.status == 200) {
      yield put(DefaultCloumnConfigActionSuccess(UserData.data));
      let catalogColumnConfigurationDetails = UserData?.data?.responseData;
      let payloadData = {
        auctionDetailId: auctionDetailId,
        userLoginId: userLoginId,
        catalogColumnConfigurationDetails: catalogColumnConfigurationDetails,
      };
      const UserData1 = yield call(
        axiosMain.post,
        `/englishauction/addmycatalogcolumnconfig`,
        payloadData
      );
      yield put(DefaultCloumnConfigActionSuccess(UserData1.data));
      yield put(DefaultCloumnConfigStutas(true));
    } else {
      yield put(DefaultCloumnConfigActionFail(UserData.data.message));
    }
  } catch (error) {
    yield put(DefaultCloumnConfigActionFail(error));
  }
}

function* GetGroupCodeById(action) {
  try {
    const auctionDetailId = action.payload.auctionDetailId;
    const userLoginId = action.payload.userLoginId;
    const UserData = yield call(
      axiosMain.get,
      `/englishauction/getgroupcode/${auctionDetailId}/${userLoginId}`
    );

    if (UserData.status == 200) {
      yield put(GetGroupCodeActionSuccess(UserData.data));
    } else {
      yield put(GetGroupCodeActionFail(UserData.data.message));
    }
  } catch (error) {
    yield put(GetGroupCodeActionFail(error));
  }
}

function* addvaluationAction(action) {
  try {
    const UserData = yield call(
      axiosMain.post,
      `/englishauction/addvaluation`,
      action.payload
    );
    if (UserData.status == 200) {
      yield put(addvaluationSuccess(UserData.data));
      yield put(addvaluationStatus(true));
      CustomToast.success(UserData.data.message);
    } else {
      yield put(addvaluationActionFail(UserData.data.message));
    }
  } catch (error) {
    yield put(addvaluationActionFail(error));
  }
}

export function* EnglishVRSaga() {
  yield all([
    takeEvery(ADD_VALUATION_ACTION, addvaluationAction),
    takeEvery(GROUP_CODE_TABLE, GetGroupCodeById),
    takeEvery(DEFULT_CONFIG_TABLE, DefaultCloumnConfigById),
    takeEvery(USERWISE_CONFIG_TABLE, UserwiseCloumnConfigById),
    takeEvery(COLUMN_CONFIG_TABLE, CatalogColumnConfigAction),
    takeEvery(GET_MARKET_DEPTH, getMarketDepthById),
    takeEvery(CHANGE_RESERVE_PRICE, ChangeReservePrice),
    takeEvery(GET_MY_CATALOG_REMOVE, RemoveMyCatalog),
    takeEvery(GET_MY_CATALOG_ADD, AddMyCatalog),
    takeEvery(GET_MY_CATALOG_VIEW, MyCatalogViewId),
    takeEvery(GET_MY_PLANNER_ENG, getMyplannerById),
    takeEvery(GET_VIEW_MARKET_SUMMARY, getviewmarketsummarById),
    takeEvery(GET_VIEW_TEA_SOLD, getViewTeaSoldById),
    takeEvery(GET_VIEW_TEA_SOLD_LOT, getViewTeaSoldByLotId),
    takeEvery(GET_VIEW_TEA_SOLD_LOT_MARKET, getViewTeaSoldMarketById),
    takeEvery(GET_VIEW_TEA_AUCTIONEER, getauctioneerById),
  ]);
}
